export function randIntInclusive(min: number, max: number): number {
  if (!Number.isFinite(min) || !Number.isFinite(max))
    throw new Error("min и max должны быть числами");
  if (Math.floor(min) !== min || Math.floor(max) !== max) {
    throw new Error("min and max must be integers");
  }
  if (max < min) throw new Error("max must be >= min");

  return Math.floor(Math.random() * (max - min + 1)) + min;
}
